import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SEO() {
  const location = useLocation();

  const canonical = `https://elmanassa.cloud${location.pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}